<script>
    import { query } from "@sinao/core-js";
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import onboardingPopoverMixin from "@/mixins/onboardingPopoverMixin";

    export default {
        components: { Multiselect },
        mixins: [onboardingPopoverMixin],
        props: {
            status: {
                type: Boolean,
                required: true,
                default: false
            }
        },
        data() {
            return {
                modalRefName: "ModalBankAccountDelete",
                bankDetailId: 0,
                selectedBankDetail: {
                    bic: null,
                    iban: null,
                    name: null,
                    id: 0
                },
                isLoading: false
            };
        },
        computed: {
            ...mapState({
                appId: state => state.app.id,
                bankdetails: state => state.home.bankdetails
            })
        },
        mounted() {
            this.$refs[this.modalRefName].$on("shown", () => this.onModalShow());
            this.$refs[this.modalRefName].$on("hidden", () => {
                this.onModalHidden();
                this.$emit("update:status", false);
                this.resetSelctedBankDetail();
            });
        },
        methods: {
            resetSelctedBankDetail() {
                this.selectedBankDetail = {
                    bic: null,
                    iban: null,
                    name: null,
                    id: 0
                }
            },
            handleOk() { //(bvModalEvt)

                // Prevent modal from closing
                //bvModalEvt.preventDefault();
                if (this.selectedBankDetail.id === 0) return
                this.handleSubmit();
            },
            async handleSubmit() {
                this.isLoading = true;

                await query({
                    operationId: "app.documents.sales.bankdetails.delete",
                    params: {
                        appId: this.appId,
                        id: this.selectedBankDetail.id
                    },
                    data: {
                    }
                });

                this.$store.dispatch("bankdetails", this.appId);

                setTimeout(() => {
                    this.isLoading = false
                }, 400);
                // Hide the modal manually
                this.$emit("update:status", false);
            }
        }
    };
</script>

<template>
    <b-modal
        :ref="modalRefName"
        :visible="status"
        :title="$t('Supprimer un RIB')"
    >
        <b-row class="pl-4 pr-4">
            <multiselect
                v-model="selectedBankDetail"
                :options="bankdetails"
                :searchable="false"
                :close-on-select="true"
                :allow-empty="false"
                :show-labels="false"
                label="name"
                track-by="name"
                :option-height="104"
                :placeholder="$t('Sélectionner un RIB')"
                class="multiSelectContainer"
            />
        </b-row>
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-row class="pl-4 pr-4">
                <b-col>
                    <label>{{ $t('Libellé') }}</label>
                    <b-form-input v-model="selectedBankDetail.name" size="sm" :placeholder="$t('Libellé du compte')" :disabled="true" />
                </b-col>
            </b-row>
            <b-row class="mt-4 pl-4 pr-4">
                <b-col>
                    <label>{{ $t('IBAN') }}</label>
                    <b-form-input v-model="selectedBankDetail.iban" size="sm" :placeholder="$t('IBAN')" :disabled="true" />
                </b-col>
            </b-row>
            <b-row class="mt-4 pl-4 pr-4">
                <b-col>
                    <label>{{ $t('BIC') }}</label>
                    <b-form-input v-model="selectedBankDetail.bic" size="sm" :placeholder="$t('BIC')" :disabled="true" />
                </b-col>
            </b-row>
        </form>

        <template #modal-footer>
            <s-button v-show="!isLoading" type="danger" @click="handleOk">{{ $t("Supprimer le RIB") }}</s-button>
            <b-spinner
                v-show="isLoading"
                variant="danger"
            />
        </template>
    </b-modal>
</template>

<style>
.multiSelectContainer {
    margin-bottom : 1rem;
    border: 1px solid var(--border);;
    border-radius: 6px;
}

</style>
